import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.grey100};
  padding: ${({ theme }) => theme.space48};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.textPrimary};
  margin: 0;
  justify-content: center;
  display: flex;
`;

export const Chart = styled.div`
  justify-content: center;
  position: relative;
  height: 75vmin;
  width: 75vmin;
  display: flex;
`;
